/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

'use strict';

import * as angular from 'angular';

declare const window: any;

//todo - use this to add generic styling/ positioning/ code to sidebar panels
angular
	.module('ticketspaceApp')
	.directive('panel', function () {
		return {
			restrict: 'EA',
			compile: function (element) {
				element.addClass('panel');
			},
		};
	})

	//<panel-head no-h1><h3>Roles</h3></panel-head>
	//<panel-head>Roles</panel-head>
	//if it needs to be more custom than this, just use the template directly
	// close button defaults to a $scope.closeSidebar() call
	// TODO - customize that
	.directive('panelHead', function () {
		return {
			template:
				'<h1></h1><button class="legacy-button panel-close" ng-click="closeSidebar();"><i class="material-icons notranslate">close</i></button>',
			transclude: true,
			link: function (scope: any, element, attrs: any, __, $transclude) {
				var h1 = element.find('h1');
				$transclude(function (clone, scope) {
					if (attrs.$attr.noH1) {
						h1.remove();
						element.prepend(clone);
					} else {
						h1.append(clone);
					}
				}, element);
			},
		};
	});
